import "./index.scss";
import { TbLayoutDashboard, TbListDetails } from "react-icons/tb";
import { CiBoxes } from "react-icons/ci";
import { useMemo } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { IoIosLogOut } from "react-icons/io";

const LeftBar = () => {
  const location = useLocation();

  const logOut = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    window.location.href = "/login";
  };

  const navItems = useMemo(
    () => [
      {
        name: "Панель управления",
        icon: <TbLayoutDashboard className="nav__linkIcon" />,
        link: "/",
      },
      {
        name: "Управление заказами",
        icon: <TbListDetails className="nav__linkIcon" />,
        link: "/orders",
      },
      {
        name: "Продукты",
        icon: <CiBoxes className="nav__linkIcon" />,
        link: "/products",
      },
      // { name: "Клиенты", icon: <TbUsers />, link: "/clients" },
      // { name: "Настройки", icon: <TbSettings />, link: "/settings" },
    ],
    []
  );

  return (
    <div className="leftBar">
      <NavLink to="/" className="leftBar__logotype">
        AgentCRM
      </NavLink>
      <ul className="leftBar__nav nav">
        {navItems.map((item, index) => (
          <li key={index} className="nav__item">
            <NavLink
              to={item.link}
              className={`nav__link ${
                location.pathname === item.link ? "nav__link_active" : ""
              }`}
            >
              {item.icon} {item.name}
            </NavLink>
          </li>
        ))}
        <li className="nav__item">
          <Link className="nav__link" onClick={logOut}>
            <IoIosLogOut className="nav__linkIcon" />
            Выйти
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default LeftBar;
